import React, { Component } from 'react';
import {
  Button,
} from 'react-bootstrap';

// components
import ChangePasswordDialog from '../../components/Auth/ChangePasswordDialog';
// css
import './Buttons.css';

class ChangePasswordButton extends Component {
  constructor(props) {
    super(props);
    this.state = { showDialog: false };
  }

  render() {
    return (
      <Button bsStyle="link" onClick={() => this.showDialog(true)}>
        Edit
        <ChangePasswordDialog
          show={this.state.showDialog}
          onSave={this.onSave}
          onCancel={() => this.showDialog(false)} />
      </Button>
    );
  }

  showDialog = (bShow = false) => {
    this.setState({ showDialog: bShow });
  }

  onSave = () => {
    this.showDialog(false);
  }
}

export default ChangePasswordButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/ChangePassword.js